export const npsColors = [
  {color: "#C54D51"},
  {color: "#DE4D52"},
  {color: "#F3754F"},
  {color: "#F58C4D"},
  {color: "#FFD552"},
  {color: "#FFD552"},
  {color: "#F0E241"},
  {color: "#D1E157"},
  {color: "#BFDA5E"},
  {color: "#8FCB7F"},
  {color: "#76a969"},
];

export const shouldShowMoodModalOnLogin = (setShowMoodModal) => {
  const {user, featureStatus} = JSON.parse(localStorage.getItem('USER_MOOD') || '{"featureStatus": 0, "user": {}, "mood": []}');
  setShowMoodModal(featureStatus && user.showModalMood === 1);
}